import { HALVE_TONGBEWEGINGEN, parse as parseHalveTong } from "./halve_tongbewegingen";
import { KRUISSTUKKEN, parse as parseKruisPunt, PUNTSTUKKEN } from "./punt_en_kruisstukken";
export const onderlegSet = new Set([...PUNTSTUKKEN.map(parseKruisPunt), ...KRUISSTUKKEN.map(parseKruisPunt), ...HALVE_TONGBEWEGINGEN.map(parseHalveTong)].map(x => x.onderlegSet));
